import { Link, Location } from '@reach/router';
import React, { useContext } from 'react';
import { Icon } from '../../../components/ui';
import { NotebookContext } from '../../../context/NotebookContext';
import UserMenu from './UserMenu';

const NotebookNavNS: React.FC = () => {
  const { notebook } = useContext(NotebookContext);

  return (
    <Location>
      {({ location }) => (
        <>
          <div className="fixed pa3 pa4-l right-0 bottom-0 z-max">
            <Link
              to="/notebook/note/new"
              data-testid="create-note"
              className="hover-bg-navy bg-blue br-100 flex items-center justify-center"
              style={{ width: 72, height: 72 }}
            >
              <Icon name="pencil" size={30} viewBox={20} color="white" />
            </Link>
          </div>

          <div className="flex-none flex items-center justify-between pa3 w-100 f7">
            <Link to="/notebook" className="ph2 hover-blue">
              <h1 className="f7 normal ph2 truncate mv0" data-testid="notebook-name">
                {notebook.name}
              </h1>
            </Link>
            <div className="flex items-center">
              <Link
                to="/notebook"
                className={`ph2 hover-blue ${location.pathname === '/notebook' ? 'blue' : 'navy'}`}
                data-testid="notebook-dashboard"
              >
                Dashboard
              </Link>

              <Link
                to="/notebook/feed"
                className={`ph2 hover-blue ${
                  location.pathname === '/notebook/feed' ? 'blue' : 'navy'
                }`}
                data-testid="notebook-feed"
              >
                Feed
              </Link>

              <Link
                to="/notebook/settings"
                className={`ph2 hover-blue ${
                  location.pathname === '/notebook/settings' ? 'blue' : 'navy'
                }`}
                data-testid="notebook-settings"
              >
                Settings
              </Link>

              <UserMenu />
            </div>
          </div>
        </>
      )}
    </Location>
  );
};

export default NotebookNavNS;
